import { readable, writable } from "svelte/store";

export const UnitsStore = writable("");
export const ReadingsStore = writable([
  {
    user_height: "",
    object_distance: "",
    units: UnitsStore,
    angle_difference: "",
    building_height: 0,
    steps: []
  }
]);
export const ThemeStore = writable("bumblebee");
let _UnitOptions = [
  { name: "Centimetres", id: "cm" },
  { name: "Metres", id: "m" },
  { name: "Inches", id: "in" },
  { name: "Feet", id: "ft" }
];
export const UnitOptions = readable(_UnitOptions);

function returnIDsToName() {
  let IDsToName = {};
  for (const el of _UnitOptions) {
    IDsToName[el.id] = el.name;
  }
  return IDsToName;
}

export const UnitOptionsIDToName = readable(returnIDsToName());
